export default Object.freeze({
    PERSONA_FISICA: 1,
    PERSONA_MORAL: 2
})
